import PropTypes from "prop-types";
import styled from "styled-components";

const Switch = ({ value = false, onChange, disabled = false, ariaLabel }) => {
	const toggleSwitch = () => {
		if (!disabled && onChange) {
			onChange(!value);
		}
	};

	return (
		<SwitchContainer
			type="button"
			role="switch"
			aria-checked={value}
			aria-label={ariaLabel}
			disabled={disabled}
			$isOn={value}
			$disabled={disabled}
			onClick={toggleSwitch}
		>
			<Knob $isOn={value} $disabled={disabled} />
		</SwitchContainer>
	);
};

Switch.propTypes = {
	value: PropTypes.bool,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	ariaLabel: PropTypes.string.isRequired,
};

export default Switch;

const SwitchContainer = styled.button`
  align-items: ${({ $isOn }) => ($isOn ? "flex-end" : "flex-start")};
  background-color: ${({ theme, $isOn, $disabled }) =>
		$disabled
			? theme.fill.defaultWeak
			: $isOn
				? theme.fill.brandMain
				: theme.fill.defaultStrong};
  border: none;
  border-radius: 24px;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  display: flex;
  flex-direction: row;
  height: ${({ theme }) => theme.sizing.md};
  padding: 2px;
  width: ${({ theme }) => theme.sizing.xl};
  flex-shrink: 0;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.border.brandStrong};
    outline-offset: 2px;
  }
`;

const Knob = styled.div`
  background-color: ${({ theme, $disabled }) =>
		$disabled ? theme.fill.defaultSubtle : theme.fill.defaultMain};
  border-radius: 24px;
  box-shadow: 0 4px 4px 0 rgb(41 41 41 / 16%);
  height: 20px;
  transform: ${({ $isOn }) => ($isOn ? "translateX(16px)" : "translateX(0)")};
  transition: transform 0.3s ease;
  width: 20px;
`;
